<analytics-header [data]="headerData"></analytics-header>

<div class="content">
    <div class="chart-row">
        <chart [chartConfig]="charts.weeklyPageViews">
            <div class="title" trans>This Week vs Last Week</div>
            <div class="subtitle" trans>By page views</div>
            <div class="chart-legend">
                <div class="legend-item" trans>This week</div>
                <div class="legend-item" trans>Last week</div>
            </div>
        </chart>

        <chart [chartConfig]="charts.browsers">
            <div class="title" trans>Top Browsers</div>
            <div class="subtitle" trans>By sessions</div>
        </chart>
    </div>

    <div class="chart-row">
        <chart [chartConfig]="charts.monthlyPageViews">
            <div class="title" trans>This Month vs Last Month</div>
            <div class="subtitle" trans>By page views</div>
            <div class="chart-legend">
                <div class="legend-item" trans>This month</div>
                <div class="legend-item" trans>Last month</div>
            </div>
        </chart>

        <chart [chartConfig]="charts.countries">
            <div class="title" trans>Top Countries</div>
            <div class="subtitle" trans>By sessions</div>
        </chart>
    </div>
</div>

<loading-indicator class="overlay" [isVisible]="loading | async"></loading-indicator>
